export const MAX_CODE_LENGTH = 5_000;
export const MAX_TEXT_LENGTH = 20_000;

export const MAX_CODE_HEIGHT = 450;

export const ROW_WIDTH = 80;
export const ROW_HEIGHT = 20;
